import React from 'react';
import { FaCheck, FaTimes, FaClock, FaTrophy } from 'react-icons/fa';

const StatusSummary = ({ filteredData, totalRecordCount }) => {
  if (!filteredData || filteredData.length === 0) return null;

  const status = filteredData[0].fld_onboardstatus;

  let icon, label, color;

  switch (status) {
    case 'Approved':
      icon = <FaCheck />;
      label = 'Complete';
      color = '#00bcd4';
      break;
    case 'Rejected':
    case 'Blocked':
      icon = <FaTimes />;
      label = 'Cancel';
      color = '#e91e63';
      break;
    case 'Contacted':
      icon = <FaClock />;
      label = 'Pending';
      color = '#9e9e9e';
      break;
    default:
      icon = <FaTrophy />;
      label = 'Total';
      color = 'blue';
      break;
  }

  return (
    <div style={{
      // border:"1px solid #ccc",
      // padding:'5px 0',
      // width:"150px",
      // borderRadius:"5px"
    }}

    >
      Show {filteredData.length} Entries of {totalRecordCount}
    </div>
  );
};

export default StatusSummary;
